@for (user of users(); track user.id; let i = $index) {
  <section class="dark">
    <div class="py-2 cursor-poiner" routerLink="/users/{{ user.id }}">
      <article
        class="postcard dark blue"
        [ngClass]="{
          'flex-plan': user.plan === plans.Flex && user.isPlanActive,
          'pro-plan': user.plan === plans.Pro && user.isPlanActive,
          'unlimited-plan': user.plan === plans.Unlimited && user.isPlanActive,
        }"
      >
        @if (user.officePhotoUrl) {
          <a class="postcard__img_link">
            <img class="postcard__img" [src]="user.officePhotoUrl" alt="Image Title" />
          </a>
        } @else {
          <div class="postcard__img_link">
            <span class="postcard__img"></span>
          </div>
        }
        <div class="postcard__text">
          <h2 class="blue">
            <a routerLink="/users/{{ user.id }}">{{ user.name }}</a>
          </h2>
          <div class="postcard__subtitle small">
            <time>
              <i class="fas fa-calendar-alt mr-2"></i>{{ 'USER_DETAILS_JOINED' | translate }}
              {{ user.createdAt | date: 'dd.MM.yyyy' }}
            </time>
          </div>
          <div class="postcard__bar"></div>
          <ul class="postcard__tagbox">
            <li class="tag__item play blue">
              <a (click)="sendEmail($event)"
                ><i class="bi bi-envelope text-light"></i> <span> {{ user.email }}</span></a
              >
            </li>
            @if (user.phoneNumber) {
              <li class="tag__item play blue">
                <a (click)="openWhatsApp($event, user.phoneNumber)"
                  ><i class="bi bi-whatsapp text-success px-1"></i>
                  <span class="phone-number-text">{{ user.phoneNumber }}</span></a
                >
              </li>
            }
            @if (user.carCount > 0) {
              <li class="tag__item">
                <i class="bi bi-car-front-fill px-1"></i>{{ user.carCount }}
              </li>
            }
            @if (user.realEstateCount > 0) {
              <li class="tag__item">
                <i class="bi bi-buildings-fill px-1"></i>{{ user.realEstateCount }}
              </li>
            }
            @if (user.city) {
              <li class="tag__item"><i class="fas fa-tag mr-2"></i>{{ user.city | translate }}</li>
            }
          </ul>
        </div>
      </article>
    </div>
  </section>
}
